import { tableConstantsFactory } from './tableConstantsFactory';
const prefix = 'PICKER';
const pickerConstants = tableConstantsFactory(prefix);
pickerConstants.SAVE_ALL_SUCCESS = "".concat(prefix, "_SAVE_ALL_SUCCESS");
pickerConstants.SERVER_SAVE = "".concat(prefix, "_SERVER_SAVE");
pickerConstants.SERVER_SAVE_ALL_FAILURE = "".concat(prefix, "_SERVER_SAVE_ALL_FAILURE");
export default pickerConstants;